export default {
  automatically_run_the_online_class: 'Automatically run the online class',
  mute_all_students_when_the_online_class_start:'Mute all students when the online class start',
  create_the_online_classroom_with_special_access_code :'create the online classroom with special access code',
  run_the_online_class_immediately:'Run the online class immediately'
}
